import gsap from 'gsap';

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Maths } from '../_app/cuchillo/utils/Maths';
import RenderTargetSketch from '../3D/RenderTargetSketch';
import { Functions } from '../_app/cuchillo/utils/Functions';
import ModelGLB from '../_app/cuchillo/3D/ModelGLB';
import { MATCAP_MATERIAL } from '../3D/constants';
import { Metrics } from '../_app/cuchillo/core/Metrics';

class ScrollItem__BlockFullAbout extends VScroll_Item {
    figure;
    letteringDom;
    _calls = {
        loop: () => this.loop()
    }
    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.figure = GetBy.class('__figure', __link)[0];

        this.init3D();

        this.onShow = () => {
            gsap.ticker.add(this._calls.loop);
        };
        this.onHide = () => {
            gsap.ticker.remove(this._calls.loop);
        };
    }

    init3D() {
        this.letteringDom = GetBy.selector('[data-3d-lettering]', this.item)[0];
        console.log(this.letteringDom);
        const modelName = '/assets/models/logo-amnesia-ok.glb';
        const matcap = '/assets/images/C09E5C_DAD2B9_654429_81582D.png';
        this.lettering = new ModelGLB({
            model: modelName,
            dom: this.letteringDom,
            cols: 22,
            matcap: matcap,
            material: MATCAP_MATERIAL.clone(),
            yFactor: .78
        });
        this.lettering.init().then(() => {
            RenderTargetSketch.group.add(this.lettering);
            this.resize();

            // console.log('LOADED', this.lettering);
        });
    }

    loop() {
        this.animationVideo();

        const { x, y, width, height } = this.letteringDom.getBoundingClientRect();
        let position = Functions.domPositionTo3D(x, y);

        // position.y = position.y + (this.y * 0.30);
        this.lettering.pos.x = (position.x + width * .5);
        this.lettering.pos.z = 350;//this.offsetZ * this.progress * .5;
        this.lettering.pos.y = ((position.y) - height * .5); // - this.offsetY * (.5 - this.progress);
        this.lettering.rot.x -= .01;

        this.lettering.update();
    }

    animationVideo() {
        const alpha =
            this.progress < 0.5
                ? Maths.normalize(0.2, 0, this.progress)
                : Maths.normalize(0.8, 1, this.progress);
        this.figure.style.opacity = alpha;

        if (alpha < 0.05) {
            document.body.classList.remove('__webgl-over-the-content');
        } else {
            document.body.classList.add('__webgl-over-the-content');
        }
    }

    dispose() {
        document.body.classList.remove('__webgl-over-the-content');

        gsap.ticker.remove(this._calls.loop);
        RenderTargetSketch.group.remove(this.lettering);
        this.lettering.dispose();

        super.dispose();
    }

    resize(__w, __h) {
        super.resize(__w, __h);

        this.lettering.resize();
    }
}

Scroll._registerClass('BlockFullAbout', ScrollItem__BlockFullAbout);
